import { render } from "./FundsManagementKabu.vue?vue&type=template&id=e0d2e88a"
import script from "./FundsManagementKabu.vue?vue&type=script&lang=js"
export * from "./FundsManagementKabu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__